<template>
  <div>
    <div class="tableSection">
      <div class="titleTable">VARIÁVEIS DE ENTRADA</div>
      <b-row>
        <b-col class="table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">
          <table class="table table-hover table-sm">
            <thead class="thead-dark">
            </thead>
            <template v-if="json2.length == 0">Sem dados para visualização<br></template>
            <tbody v-else>
              <tr v-for="item in json2" :key="item.id">
                <td v-if="item.root == 'true'" class="text-truncate tableTxt area" colspan="15"
                  style="max-width: 250px; text-overflow: ellipsis">
                  {{ item.item }}
                </td>
                <template v-else>
                  <td class="text-truncate tableTxt" style="max-width: 250px; text-overflow: ellipsis">
                    {{ item.item }}
                  </td>
                  <td class="text-truncate tableTxt" style="max-width: 250px; text-overflow: ellipsis">
                    <b-form-input :id="'item-' + item.id" step="0.01" class="inputDataGrid input-pentagro"
                      v-model="item.value" type="number" @change="safeNumber(item.value, item.id)" placeholder="0.00"
                      :disabled="item.root == 'true' || isProductionPlanBase" required></b-form-input>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { urlMainAPI } from "@/global";
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "GridInputPlan",

  inject: ["showLoading"],

  components: {},

  computed: mapState(["msg"]),

  watch: {
    async valorSelect() {
      await this.loadtable();
    },

    async revisionSelect() {
      await this.loadtable();
    },

    updateTableEvent(data) {
      data.forEach(item => { if (item.value) item.value = item.value.replace(',', '.') })
      this.json2 = data;
    },

    json2() {
      this.$emit("tableInput", this.json2)
    },
    revisionSelected(value) {
      this.isProductionPlanBase = value.isBase
    }
  },
  props: ["valorSelect", "yearSelect", "revisionSelect", "updateTableEvent", "resultInputs", "revisionSelected"],
  data: function () {
    return {
      json2: [],
      isProductionPlanBase: false
    };
  },
  filters: {},
  methods: {
    safeNumber(num, id) {
      num = num.toLocaleString('pt-br', { minimumFractionDigits: 2 });
      document.querySelector('#item-' + id).innerText = num;
    },

    async loadtable() {
      if (this.yearSelect != null) {
        const url = `${urlMainAPI}/getproductionplaninput/${this.yearSelect}/${this.revisionSelect.id}/${this.valorSelect}`;
        await axios
          .get(url)
          .then((res) => {
            res.data.table.forEach(item => { if (item.value) item.value = item.value.replace(',', '.') })
            this.json2 = res.data.table;
            this.$emit("tableInput", this.json2)
          })
          .catch();
      }
    },

  },
  created() { },
  mounted() { },
  updated() { }
};
</script>

<style scoped>
.titleTable {
  text-align: center;
  margin: 10px auto 5px auto;
  border-bottom: 2px solid black;
}

.inputDataGrid {
  border: 1px solid #ff9050;
  float: right;
  border-radius: 3px;
  padding: 0 0 0 4.8px;
  height: 22px;
  font-size: 12px;
  max-width: 73.5px;
  outline: none;
  -moz-appearance: textfield;
  appearance: textfield;
}

.inputDataGrid:focus {
  box-shadow: 1px 1px 3px #ff5e00b9;
}

.inputDataGrid[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;

}

table {
  border-collapse: initial;
  border-spacing: initial;
  font-size: 12px;
}

.my-custom-scrollbar {
  max-height: 26vh;
  overflow: auto;
  margin: 0px auto;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.waitTxt {
  justify-content: center;
  background: black;
  color: white;
  margin: 10px auto;
  min-width: 300px;
  max-width: 400px;

}

.rowDistance {
  margin-top: 20px;
}

.tableSection {
  margin: 0px;
}

.area {
  background-color: rgb(59, 58, 58);
  color: white;
  text-align: center;
}
</style>
